<template>
    <article >

     <div class="top-section">
    <h1>Emissaries</h1>
    <br>
    Emissary in the Squat of Gods<br>
    Emissary Forks At Perfection<br>
    Emissary Sunsets The Self<br><br>
    2015-2017<br><br>

    <img id="news-image" src="http://emissaries.live/assets/emissaries_fauna_sm.jpg" width="100%"/>
    </div>

   <div class="synopsis">
      <h3>Synopsis</h3>
      <p class="big-text">Emissaries is a trilogy of simulations about cognitive evolution, past and future, and the ecological conditions that shape it. It is composed of three interconnected simulations, each centered on the life of an emissary who is caught between unraveling old realities and emerging weird ones.
      </p>

     <div class="ep-column">
      <p class="indent-text">
              <img id="emissary-icon" src="https://d2w9rnfcy7mm78.cloudfront.net/2455860/display_7960cb78aa8fbef4b421a85494aeb0c9.png" />

       <b>Emissary in the Squat of Gods</b> simulates an ancient community living with the threat of a volcanic eruption. We follow Young Ancient [Emissary], a child who experiences the first flicker of narrative consciousness, threatening the authority of vocal hallucinations that guide the decisions of her pre-conscious community.
      </p>
    </div>

     <div class="ep-column">
     <p class="indent-text">
         <img id="emissary-icon" src="https://d2w9rnfcy7mm78.cloudfront.net/2455585/display_ffac4fea7e3473c5421c915a223a84e9.png" />
        <b>Emissary Forks At Perfection</b> takes place many thousands of years in the future, the volcano now a fertile Darwinian playground managed by an AI. During its post-mortem analysis on humankind, AI resurrects the remains of a 21st century human celebrity into this unrecognizable world and sends Shiba [Emissary], a canine superpet, to extract one final impression of man under stress.

      </p>
    </div>

     <div class="ep-column">
      <p class="indent-text">
         <img id="emissary-icon" src="https://d2w9rnfcy7mm78.cloudfront.net/2455622/display_c572f2f995faf7d9d8ceb3b7e6749739.png" width="10%"/>
       <b>Emissary Sunsets the Self</b> simulates the peak days of AI, now evolved into an oceanic substance and merged with the landscape to form a Sentient Atoll. Tired of its god-like agency, it begins to provoke radical mutations in search of a generative death and sends a Puddle of itself into the Atoll’s bio layer. We follow AI Puddle [Emissary] as it drones a local Wormleaf anemone and navigates the sensations of its new terrestrial umwelt, only to be confronted by the prejudice of the Oomen— a garish population engineered to immunize the landscape from monstrous deviations.
      </p>
    </div>
  </div>
   <section class="padding-text">
      <h3>Exhibition History</h3>
        <ul v-if="emissaryExhibits" >
          <li v-for="(xbt, index) in emissaryExhibits" :key="xbt.id" >
            <a v-if="index < 100" :href="xbt['Website']" target="_blank" rel="nofollow">
              <span v-html="getYear(xbt['Opening Date'])"></span>&nbsp;
              {{xbt.Venue}} ~ <i>{{xbt['Show Title']}}</i> ~ {{xbt.City.split(',')[0]}}
            </a>

          </li>
        </ul>
</section>

<section class="padding-text">
<h3>Press & Interviews on Emissaries</h3>
  <ul v-if="emissaryPressClips" >
          <li v-for="(emPr, index) in emissaryPressClips" :key="emPr.id" >
               <a v-if="index < 20" :href="emPr['Link']" target="_blank" rel="nofollow">
                <span v-html="getYear(emPr['Date'])"></span>&nbsp;
              {{emPr['Publication']}}, <i>{{emPr['Title']}}</i>, by {{emPr['Author']}}
              </a>
          </li>
        </ul>
</section>
<div class="synopsis">
<h3>Production Credits</h3>
 <p>
  <b>Emissary in the Squat of Gods</b> (live simulation, 2015) <i>Created by</i>  Ian Cheng, <i>Producer</i>  Veronica So, <i>Technical Director</i>  Samuel Eng, <i>Modeling & Rigging</i> Joshua Planz, <i>Modeling</i> Breht O'Hearn, <i>Sound Design</i>  Greg Heffernan, <i>Technical Artists</i>  Mark Fingerhut + Ian Faris, <i>Animation</i> Jeremy Riccione, <i>Content Designer</i>  Jessica Wilson, <i>Concept Artist</i>  Andrej Ujhazy, <i>Choreography</i>  Madeline Hollander, <i>Mocap Performances</i> Jeremy Pheiffer + David Yijae, <i>Mocap Services</i> Edit1 + Xsens, <i>Story Consultant</i> Sean Manning + Alexander Benaim, <i>Published by</i> Metis Suns.
</p>
      <p>
<b>Emissary Forks At Perfection</b> (live simulation, 2015-2016) <i>Created by</i>  Ian Cheng, <i>Producer</i>  Veronica So, <i>Technical Director</i>  Samuel Eng, <i>Modeling & Rigging</i>  Joshua Planz,  <i>Modeling</i>  Breht O'Hearn + Aaron Bohenick, <i>Sound Design</i>  Greg Heffernan, <i>Animation</i>  Chad Waldschmidt, <i>Graphics Programmer</i>  Chris Clapis, <i>Content Designer</i> Jessica Wilson, <i>Technical Artists</i>  Yang Wang + Zhenzhen Qi, <i>Story Consultant</i> Sean Manning + Alexander Benaim, <i>Published by</i> Metis Suns.
</p>
      <p>
<b>Emissary Sunsets the Self</b> (live simulation, 2017) <i>Created by</i>  Ian Cheng, <i>Producer</i>  Veronica So, <i>Technical Director</i>  Samuel Eng, <i>AI Development</i> Porrith Suong + Jay Suong, <i>Modeling & Rigging</i>  Joshua Planz, <i>Sound Design</i> Steve Green, <i>Animation</i> Chad Waldschmidt, <i>Concept Artist</i>  Andrej Ujhazy, <i>Content Designer</i>  Jessica Wilson, <i>Technical Artists</i>  Yang Wang + Zhenzhen Qi, <i>Graphics Programmer</i>  James Cao, <i>Story Consultant</i>  Andrew Chan Gladstone + Alexander Benaim, <i>Published by</i> Metis Suns.
</p>
__
<p>
  <b>Emissaries Park Guide</b> (pamphlet, 2017) <i>Created by</i>  Ian Cheng, <i>Producer</i>  Veronica So, <i>Graphic Design</i> Scott Langer & Sunny Park, <i>Published by</i> Metis Suns.
</p>
__
<p>
  <b>Emissaries Guide To Worlding</b> (catalog, 2018) <i>Text & Images by</i>  Ian Cheng, <i>Contributions by </i>Hans Ulrich Obrist + Nora Khan + Ben Vickers, <i>Graphic Design</i> Bureau Borsche, <i>Glyphs by</i> Andrej Ujhazy, <i>Edited by</i>  Rebecca Lewin + Joseph Constable + Veronica So, <i>Published by</i> Serpentine Galleries + Koenig Books, <i>Produced by</i> Fondazione Sandretto Re Rebaudengo, <i>ISBN</i> 978-1-908617-50-7.
</p>

</div>
<section>
  <h3 class="padding-text">Images</h3>
  <viewer channelSlug = 'emissaries-overview' />
  <viewer channelSlug = 'eitsog' />
  <viewer channelSlug = 'efap' />
  <viewer channelSlug = 'ests' />
</section>

<!-- <section>
<h3 class="padding-text">Production Drawings</h3>
<viewer channelSlug = 'eitsog-drawings' />
<viewer channelSlug = 'efap-drawings' />
<viewer channelSlug = 'ests-drawings' />
</section> -->

  </article>

</template>

<script>
// import Images from '@/views/Images.vue'
import Viewer from '@/views/Viewer.vue'
import { mapState, mapActions } from 'vuex' // imports from our Store
export default {
  name: 'Emissaries',
  components: { Viewer },
  computed: {
    // Store data imported from /src/store.js
    ...mapState(['exhibitions', 'bibliography', 'press']),
    emissaryExhibits () {
      return this.filterXbts2('Emissaries')
    },
    emissaryPressClips () {
      return this.filterEmissaryPress('Emissaries')
    },
    solo () {
      return this.filterXbts('Solo Exhibition')
    },
    group () {
      return this.filterXbts('Group Exhibition')
    },
    events () {
      return this.filterXbts('Events')
    },
    texts () {
      if (!this.bibliography || !this.press) return null
      const list = [...this.bibliography, ...this.press] // ES6
      return list.sort(this.sortDescByKey('Date'))
    }
  },
  methods: {
    // Actions from Store
    ...mapActions(['getExhibitions', 'getBibliography', 'getPress']),

    getRecords () {
      // Get records if don't exist already
      if (!this.exhibitions) this.getExhibitions()
      if (!this.bibliography) this.getBibliography()
      if (!this.press) this.getPress()
    },
    sortDescByKey (key) {
      return (a, b) => new Date(b[key]) - new Date(a[key])
    },
    filterXbts (type) {
      // const xbtsugh = this.$store.state.exhibitions
      // if (!xbtsugh) xbtsugh = []
      if (!this.exhibitions) return []
      const xbts = this.exhibitions.filter(rec => rec['Type of Exhibition'] === type)
      return xbts // xbts.sort(this.sortDescByKey('Opening Date'))
    },
    filterXbts2 (type) {
      if (!this.exhibitions) return []
      const xbts2 = this.exhibitions.filter(rec => rec['Project Focus'] === type)
      return xbts2 // xbts.sort(this.sortDescByKey('Opening Date'))
    },
    filterEmissaryPress (type) {
      // const pressugh = this.getPress()
      // if(!pressugh) pressugh = []
      if (!this.press) return []
      const emPress = this.press.filter(rec => rec['Project Focus'] === type)
      return emPress // xbts.sort(this.sortDescByKey('Opening Date'))
    },
    getYear: date => { date = new Date(date); return date.getFullYear() }
  },
  created () {
    this.getRecords()
  }
}
</script>

<style scoped>

#emissary-icon{
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.ep-column{
  display:block;
  width: 30%;
  min-width: 200px;
  float:left;
  margin-left: 10px;
  margin-right: 10px;
}
.top-section{
  float:left;
  clear:both;
  width: 100%;
  font-size: 1em;
  border-bottom: 1px solid #ddd;
  text-align: center;
  margin-top: 20px;
}

.big-text{
  font-size: 1.25em;
}

.indent-text{
  font-size: 1em;
  border-radius: 7px;
  padding: 12px;
  border: 1.2px solid rgb(204, 204, 204);
  box-shadow: 3px 3px 8px #ddd;
  margin-bottom: 6px;

}

.synopsis{
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding: 20px;
  clear:both;

}

section{
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  clear:both;
}

.padding-text{
  padding: 20px;
}

h1{
  text-align:center;
  font-size: 2em;
}

h3{
  text-align:left;
  font-size: 1em;
  margin-bottom: 10px;
}

li{
  line-height: 1.2em;
}

#news-image{
  margin: auto;
   display: block;
  text-align: center;
  border: solid 1px #ddd;
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>
